import { useEffect, useState } from 'react';

export default function FragrancesHero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  return (
    <section className="relative w-full h-[60vh] min-h-[400px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=luxury%20perfumery%20ingredients%20artfully%20scattered%20across%20dark%20reflective%20surface%20glass%20droppers%20golden%20amber%20liquid%20dried%20flowers%20vanilla%20pods%20sandalwood%20chips%20rose%20petals%20soft%20dramatic%20studio%20lighting%20warm%20golden%20tones%20dark%20moody%20background%20high-end%20editorial%20photography%20shallow%20depth%20of%20field&width=1400&height=800&seq=fragrances-hero-v2&orientation=landscape)',
        }}
      />
      <div className="absolute inset-0 bg-black/50" />
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-6">
        <div className={`transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight mb-6">
            Fragancias
          </h1>
          <div className="w-16 h-px bg-white/40 mx-auto" />
        </div>
      </div>
    </section>
  );
}